// FINDING A MEETING AFTER IT TOOK PLACE (077). The calendar moves by date; this asks the
// server across every date — title, client, the outside person and their details, job and
// summary — newest first. While there is a search its results replace the window in list
// mode's own table; clearing the box brings the window back.
//
// The server does the matching (meetings/find.js): the browser holds one window of
// meetings, and the meeting worth finding is usually outside it. A hook rather than a
// component, so the screen can open a found meeting from these rows and see it refreshed
// after a save like any other.
import { useEffect, useState } from 'react';
import useAsync from '../../hooks/useAsync';
import { meetingsApi } from '../../api/calendar';

const MIN_LENGTH = 2;
const DELAY_MS = 300;

// The text settles before it is sent, so typing a name is one request rather than five.
const useSettled = (value) => {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), DELAY_MS);
    return () => clearTimeout(timer);
  }, [value]);
  return settled;
};

export const isSearching = (query) => query.trim().length >= MIN_LENGTH;

export default function useMeetingSearch(query, version) {
  const text = useSettled(query.trim());
  const { data, loading, error } = useAsync(
    () => (text.length >= MIN_LENGTH ? meetingsApi.search(text) : Promise.resolve([])),
    [text, version],
  );
  return { found: data || [], loading, error };
}
